/**
 * 指定した日時を'2020-01-01'の形式の文字列で返す
 * @param {number} year
 * @param {number} month
 * @param {number} day
 */
export const stringifyDate = (year, month, day) => {
    return `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
};
